/*
|--------------------------------------------------------------------------
| App.TS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// Automatically includes TS/JS from the /components directory
import autoTemplateComponent from './core/auto-template-component'

// Footer shader animation
import './footer-shader'
import { values } from './values'

// Mobile navigation
import { initMobileNav, initStickyHeader } from './nav'

// Web Components
import './components/x-profile-modal'

values()
autoTemplateComponent()
initMobileNav()
initStickyHeader()
